import { useExperiment } from '@app/experiments';
import { EXPERIMENTS } from '@app/config';

const useAccountDebugMenu = (): Boolean => {
  const showDebugMenu = useExperiment(
    EXPERIMENTS.web_platform_enable_debug_menu,
  ) as Boolean;

  return showDebugMenu;
};

export default useAccountDebugMenu;
